import React from 'react';

import Message from 'components/Message';
import Typography, { TypographyVariant } from 'components/Typography';

import { ActiveSubscriptionFragment } from 'graphql/generated/graphql';

import { Color } from 'types/colors';

interface TrialProgressBarProps {
  activeSubscription: ActiveSubscriptionFragment;
  variant?: TypographyVariant;
  centered?: boolean;
  color?: Color;
}

const TrialProgressBar = ({
  activeSubscription,
  variant = 'h4',
  centered = false,
  color = 'white',
}: TrialProgressBarProps) => {
  const totalTrialDaysInTime =
    new Date(activeSubscription.freeTrialEndsAt).getTime() -
    new Date(activeSubscription.freeTrialStartedAt).getTime();

  const daysLeftInTime =
    new Date(activeSubscription.freeTrialEndsAt).getTime() - Date.now();

  const daysLeftInDays = Math.round(daysLeftInTime / (1000 * 3600 * 24));

  const progress = Math.round(
    100 - (daysLeftInTime * 100) / totalTrialDaysInTime,
  );

  return (
    <div
      className="TrialProgressBar flex flex-col relative p-4 gap-2 bg-soft-sensual-bg md:max-w-content-max md:mx-auto"
      data-testId="trial-progress-bar"
    >
      <Typography variant={variant} color={color} centered={centered}>
        <Message
          message={{
            id: 'components.TrialProgressBar.title',
            values: { days: daysLeftInDays },
          }}
        />
      </Typography>
      <div className="TrialProgressBar__ProgressBar__wrapper h-4 bg-white rounded-2xl">
        <div
          style={{
            width: `${progress}%`,
          }}
          className="TrialProgressBar__ProgressBar h-4 bg-primary rounded-2xl"
        />
      </div>
    </div>
  );
};

export default TrialProgressBar;
